import { handleGetDiscoverListingAction } from "@/actions/discover.action";
import { DiscoverItem } from "@/components/home/sections/discover/discover.type";
import { ApiResult } from "@/types/api";
import { useQuery } from "@tanstack/react-query";

/** ******************************
 * GET: Discover Listing
 ****************************** */
const useGetDiscoverListing = (enabled = true) => {
  return useQuery<ApiResult<DiscoverItem[]>, Error, DiscoverItem[]>({
    queryKey: ["discover-listing"],
    queryFn: () => handleGetDiscoverListingAction(),
    enabled,
    staleTime: 1000 * 60 * 5,
    select: (res) => res.data,
  });
};

const useGetDiscoverDetail = (id: number) => {
  return useQuery<ApiResult<DiscoverItem[]>, Error, DiscoverItem | undefined>({
    queryKey: ["discover-details", id],
    queryFn: () => handleGetDiscoverListingAction(),
    staleTime: 1000 * 60 * 5,
    select: (res) => res.data.find((item) => item.id === id),
    enabled: Number.isFinite(id),
  });
};

const useGetDiscoverRelated = (id: number, limit = 5) => {
  return useQuery<ApiResult<DiscoverItem[]>, Error, DiscoverItem[]>({
    queryKey: ["discover-related", id, limit],
    queryFn: () => handleGetDiscoverListingAction(),
    staleTime: 1000 * 60 * 5,
    select: (res) => {
      const rest = res.data.filter((item) => item.id !== id);
      const after = rest.filter((item) => item.id > id);
      const before = rest.filter((item) => item.id < id);
      // Prefer items after the current one; fill from the rest if not enough
      return [...after, ...before].slice(0, limit);
    },
    enabled: Number.isFinite(id),
  });
};

export { useGetDiscoverListing, useGetDiscoverDetail, useGetDiscoverRelated };
